import { FormattedMessage } from "react-intl";
import AdminIcon from "../components/Common/SvgIcons/SidebarIcons/AdminIcon";
import DashBoardIcon from "../components/Common/SvgIcons/SidebarIcons/DashBoardIcon";
import DistributeIcon from "../components/Common/SvgIcons/SidebarIcons/DistributeIcon";
import EventsIcon from "../components/Common/SvgIcons/SidebarIcons/EventsIcon";
import ManageIcon from "../components/Common/SvgIcons/SidebarIcons/ManageIcon";
import OrganizeIcon from "../components/Common/SvgIcons/SidebarIcons/OrganizeIcon";
import ReportsIcon from "../components/Common/SvgIcons/SidebarIcons/ReportsIcon";
import SocialIcon from "../components/Common/SvgIcons/SidebarIcons/SocialIcon";
import { roleMenuList } from "./roleMenuList";
import { featureList } from "./featureList";
import HomeIcon from "../components/Common/SvgIcons/SidebarIcons/HomeIcon";

export const sidebarTabs = (tenantName) => [
  {
    key: 1,
    name: "Home",
    icon: (fill) => <HomeIcon fill={fill} />,
    path: `/${tenantName}/home`,
  },
  {
    key: 2,
    name: <FormattedMessage id="MANAGE_TEXT" />,
    icon: (fill) => <ManageIcon fill={fill} />,
    path: `/${tenantName}/manage`,
    feature: [
      {
        roleMenu: roleMenuList?.MANAGE?.CREATE_SHOTCLASS,
        MSOMMenu: "",
      },
    ],
  },
  {
    key: 3,
    name: <FormattedMessage id="MYEVENT" />,
    icon: (fill) => <EventsIcon fill={fill} />,
    path: `/${tenantName}/events`,
    // type: [roleMenuList?.EVENTS?.LIVE_QUIZ, roleMenuList?.EVENTS?.VIRTUAL_QUIZ],
    // feature: [featureList?.LIVE_QUIZ, featureList?.VIRTUAL_QUIZ],
    feature: [
      {
        roleMenu: roleMenuList?.EVENTS?.LIVE_QUIZ,
        MSOMMenu: featureList?.LIVE_QUIZ,
      },
      {
        roleMenu: roleMenuList?.EVENTS?.VIRTUAL_QUIZ,
        MSOMMenu: featureList?.VIRTUAL_QUIZ,
      },
    ],
  },
  {
    key: 4,
    name: <FormattedMessage id="DISTRIBUTE_DIST_TEXT" />,
    icon: (fill) => <DistributeIcon fill={fill} />,
    path: `/${tenantName}/distribute`,
    // type: [roleMenuList?.DISTRIBUTE],
    feature: [
      {
        roleMenu: roleMenuList?.DISTRIBUTE,
        MSOMMenu: "",
      },
    ],
  },
  {
    key: 5,
    name: "Organize",
    icon: (fill) => <OrganizeIcon fill={fill} />,
    path: `/${tenantName}/organize`,
  },
  {
    key: 6,
    name: <FormattedMessage id="ADMIN_TEXT" />,
    icon: (fill) => <AdminIcon fill={fill} />,
    path: `/${tenantName}/admin`,
    feature: [
      {
        roleMenu: roleMenuList?.ADMIN?.VIEW_ROLE_AND_PERMISSION,
        MSOMMenu: "",
      },
    ],
  },
  {
    key: 7,
    name: <FormattedMessage id="SOCIAL" />,
    icon: (fill) => <SocialIcon fill={fill} />,
    path: `/${tenantName}/social`,
    type: [
      roleMenuList?.SOCIAL?.POLL_MANAGEMENT,
      roleMenuList?.SOCIAL?.FORUM_AREA,
      roleMenuList?.SOCIAL?.MODERATE_CONTRIBUTION,
    ],
    // feature: [
    //   {
    //     roleMenu: roleMenuList?.SOCIAL?.POLL_MANAGEMENT,
    //     MSOMMenu: featureList?.POLL,
    //   },
    //   {
    //     roleMenu: roleMenuList?.SOCIAL?.FORUM_AREA,
    //     MSOMMenu: featureList?.FORUM,
    //   },
    //   {
    //     roleMenu: roleMenuList?.SOCIAL?.MODERATE_CONTRIBUTION,
    //     MSOMMenu: "",
    //   },
    // ],
  },

  {
    key: 8,
    name: "Reports",
    icon: (fill) => <ReportsIcon fill={fill} />,
    path: `/${tenantName}/reports`,
    type: [roleMenuList?.REPORTS],
  },
];
